{/* Copyright 2026 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. */}

import {Layout} from '../../../src/Layout';
export default Layout;
import {FunctionAPI} from '../../../src/FunctionAPI';
import {InterfaceType} from '../../../src/types';
import docs from 'docs:@react-aria/link';

export const section = 'Hooks';
export const description = 'Provides the behavior and accessibility implementation for a link.';
export const isSubpage = true;

# useLink

<PageDescription>{docs.exports.useLink.description}</PageDescription>

```tsx render files={["starters/hooks/src/Link.tsx", "starters/hooks/src/Link.css"]}
"use client";
import {Link} from 'hooks-starter/Link';

<Link href="https://adobe.com" target="_blank">Adobe</Link>
```

## API

<FunctionAPI function={docs.exports.useLink} links={docs.links} />

### AriaLinkOptions

<InterfaceType {...docs.exports.AriaLinkOptions} />

### LinkAria

<InterfaceType {...docs.exports.LinkAria} />
